import type { FilterSpecification } from 'maplibre-gl';

export const SOURCE_ID = 'activity-heatmap';
export const HEAT_LAYER_PREFIX = 'activity-heatmap-heat-';
export const AREA_LAYER_PREFIX = 'activity-heatmap-area-';
export const OUTLINE_LAYER_PREFIX = 'activity-heatmap-outline-';
export const MARKER_LAYER_PREFIX = 'activity-heatmap-marker-';
export const MARKER_HOVER_LAYER_ID = 'activity-heatmap-marker-hover';
export const MARKER_IMAGE_PREFIX = 'activity-heatmap-icon-';
export const SELECTED_MARKER_SOURCE_ID = 'selected-marker';
export const LAYER_ID_PREFIX = 'activity-heatmap';

export function heatLayerId(eventType: string): string {
    return `${HEAT_LAYER_PREFIX}${eventType}`;
}

export function areaLayerId(eventType: string): string {
    return `${AREA_LAYER_PREFIX}${eventType}`;
}

export function outlineLayerId(eventType: string): string {
    return `${OUTLINE_LAYER_PREFIX}${eventType}`;
}

export function markerLayerId(eventType: string): string {
    return `${MARKER_LAYER_PREFIX}${eventType}`;
}

/** Sentinel feature_id filter so the hover overlay matches nothing. */
export const HOVER_FILTER_NONE: FilterSpecification = ['==', ['get', 'feature_id'], ''];

export const MARKER_IMAGE_SIZE_PX = 64;
export const MARKER_IMAGE_PIXEL_RATIO = 2;
export const MARKER_ICON_INSET_PX = 16;
export const MARKER_ICON_SIZE_PX = MARKER_IMAGE_SIZE_PX - MARKER_ICON_INSET_PX * 2;
const MARKER_DISPLAY_SIZE_PX = MARKER_IMAGE_SIZE_PX / MARKER_IMAGE_PIXEL_RATIO;

/** Match regular map pin hover grow (see useMapInitializer). */
export const ICON_SCALE = 1;
export const ICON_SCALE_HOVERED = 1.2;
export const HOVERED_MARKER_SORT_KEY = 100;
export const DEFAULT_MARKER_SORT_KEY = 0;
/** Debounce leave so layout/hit-test frames don't thrash enter→leave→enter. */
export const MARKER_HOVER_LEAVE_DELAY_MS = 60;

/** World-unit coverage wash — barely there; density heat is the primary signal. */
export const CLUSTER_FILL_OPACITY = 0.05;
export const CLUSTER_OUTLINE_OPACITY = 0.55;
export const CLUSTER_OUTLINE_WIDTH = 2;
export const DEFAULT_CLUSTER_COLOR = '#FF8A3D';

/**
 * Tooltip sits above the marker. Offset is sized for the *hovered* scale so the gap
 * between marker top and tooltip bottom stays consistent (same approach as pin tooltips).
 */
const MARKER_TOOLTIP_GAP_PX = 8;
export const MARKER_TOOLTIP_OFFSET =
    Math.round((MARKER_DISPLAY_SIZE_PX * ICON_SCALE_HOVERED) / 2) + MARKER_TOOLTIP_GAP_PX;
